import VError from './error';
import Notify from './notify';

const $ = require('jquery');

$(document).ready(function () {
    // Init error handler
    VError.init();

    // Initiate notifications
    Notify.init($('#notifyTemplate'));

    // Google Analytics for production
    if ($.inArray(window.location.hostname,['admin.virta.fi','admin.virta-ev.com']) >= 0) {
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments)
            }, i[r].l = 1 * new Date();
            a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m)
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

        ga('create', 'UA-59562876-6', 'auto');
        ga('send', 'pageview');
    }
});

/**
 * Helper function to remove empty child objects and undefined properties
 * @param obj {object}
 * @returns {object}
 */
export function removeEmptyAndUndefinedProps(obj) {
    for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
            if (obj[p] === null || Array.isArray(obj[p])) {
                // Null is not undefined, so keep that
                // Also arrays are ok
                continue;
            }
            if (typeof obj[p] === 'undefined') {
                delete obj[p];
                continue;
            }

            if (typeof obj[p] === 'object') {
                obj[p] = removeEmptyAndUndefinedProps(obj[p]);
                if (Object.getOwnPropertyNames(obj[p]).length === 0) {
                    delete obj[p];
                }
            }
        }
    }

    return obj;
}

export function reloadPage(fromServer = true) {
    location.reload(fromServer);
}

export function pushHistory(data = null, title = null, href = null) {
    if (data === null) data = [];
    if (title === null) title = document.title;
    if (href === null) href = window.location.href;
    history.pushState(data, title, href);
}